<template>
<div>
    <div class="head-section"  :data-navbarid="'topmenu-item_' + section.id">    
        <div v-if="!section.is_popup">
            <div class="px-4 pb-4" :class="[$root.hotelCode == 'marriottpolyana' || $root.hotelCode == 'marriottimperialplaza' || $root.hotelCode === 'marriottroomservice' || $root.hotelCode === 'marriott-krasnodar' || $root.hotelCode === 'marins-nsk' || $root.hotelCode === 'marins-astrakhan' || $root.hotelCode === 'marins-nn' || $root.hotelCode === 'yaltaintourist' || $root.hotelCode === 'marins-ek' || $root.hotelCode === 'marins-rostov' || $root.hotelCode === 'marins-moscow' || $root.hotelCode === 'tropikana' ? 'header_products_marriot' : 'header_products']">
                <span class="section-title">{{ $root.getLangText(section.title) }}</span>
            </div>
        </div>
    </div>
    
    <div class="px-4 pb-4 flex items-center gap-1" v-if="!section.in_schedule && displayScheduleText(section, false)">
        <span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>
        <span>{{ displayScheduleText(section, false) }}</span>
    </div>

    <div class="text-gray-600 text-xs p-2" v-if="$root.stripTags($root.getLangText(section.descr)).length > 0" v-html="$root.getLangText(section.descr)"></div>

    <div  :class="[templateView == 'grid' || templateView == 'grid_np' ? 'flex flex-wrap' : '']">
        <article-product
            v-for="item in section.products"
            @click.native="eventBus.$emit('show-cart', {'item':item,'section':section})"
            :key="item.id"
            :item="item"
            :section="section" 
            :parent-section="parentSection"
            :template-view="templateView"
            :class="{ 'opacity-50' : (!item.in_schedule || !section.in_schedule) }">
        </article-product>
    </div>
</div>

</template>

<script>
import ArticleProduct from './ArticleProduct';
import {eventBus} from "@/main";

export default {
    props: {
        section: {},
        parentSection: {},
        showCart: Function
    },
    
    computed: {
        eventBus() {
            return eventBus
        },
        templateView() {
            return this.section.template_view 
                ? this.section.template_view 
                : this.parentSection.template_view;
        }
    },

    components: {
        ArticleProduct
    },
}
</script>